import { defineStore } from 'pinia'
import { axiosInstance } from 'boot/axios'

export const useCategoriesStore = defineStore('categories', {
  state: () => ({
    items: [],
    selected: {
      name: '',
      url: '',
      id: null
    }
  }),
  actions: {
    fetch(menuId) {
      return axiosInstance
        .get(`public/categories?menu_id=${menuId}`)
        .then(({ data }) => {
          this.items = data.categories
        })
        .catch(() => {
          this.items = []
        })
    },
    setSelected(category) {
      this.selected = category
    },
    setItems(items) {
      this.items = items
    }
  }
})
